import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { MerchantDto } from 'src/generated-api-client';

type MerchantBusinessInfoCardProps = {
    merchant?: MerchantDto;
};

export const MerchantBusinessInfoCard = observer(
    ({ merchant }: MerchantBusinessInfoCardProps) => {
        return (
            <Card title={t('Merchant.BusinessInformation.Title')}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.JoiningDate')}
                            value={merchant?.joiningDate}
                            formatValue="date"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.TenureDays')}
                            value={merchant?.tenureDays}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.LastOrderDate')}
                            value={merchant?.lastOrderDate}
                            formatValue="date"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.TotalBranches')}
                            value={merchant?.totalBranches}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Metrics.TotalCustomers')}
                            value={merchant?.metrics?.totalCustomers}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Metrics.TotalOrders')}
                            value={merchant?.metrics?.totalOrders}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Metrics.TotalAmount')}
                            value={merchant?.metrics?.totalAmount}
                            formatValue="currency-sar"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Metrics.AOV')}
                            value={merchant?.metrics?.aov}
                            formatValue="currency-sar"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Metrics.OneTimeSharePct')}
                            value={merchant?.metrics?.oneTimeSharePct}
                            formatValue="percent"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Metrics.RepeatShare')}
                            value={merchant?.metrics?.repeatSharePct}
                            formatValue="percent"
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
